/**
 * The `code` a failed Google lookup carries in its HTTP error body.
 *
 * Shared because the SPA branches on these values: only a throttled Google
 * (`UNAVAILABLE`) must not be retried; a timeout or a Google 5xx may be.
 */
export const GOOGLE_LOOKUP_ERROR_CODES = {
  CONSENT_REQUIRED: 'google_consent_required',
  UNAVAILABLE: 'google_unavailable',
  REQUEST_FAILED: 'google_request_failed',
  TIMEOUT: 'google_timeout',
  SERVER_ERROR: 'google_server_error',
} as const;
